import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './table-row-simple.scss?inline';

export default class SotbitTableRowSimple extends LitElement {
    static styles = [
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    render() {
        return html`<slot></slot>`;
    }
}
